import { useTrans } from "@/translations";

import type React from "react";

import { twMerge } from "tailwind-merge";

import { REPORTING_TAB_TYPES, REPORTING_VIEW_TYPES } from "../types";

type Props = {
  viewType: REPORTING_VIEW_TYPES;
  setViewType: (value: REPORTING_VIEW_TYPES) => void;
  setTabType: (value: REPORTING_TAB_TYPES) => void;
};

const BUTTONS = [
  {
    id: REPORTING_VIEW_TYPES.PORTFOLIO,
    labelKey: "reportingPage:viewTypePortfolioLabel",
  },
  {
    id: REPORTING_VIEW_TYPES.BUILDING,
    labelKey: "reportingPage:viewTypeBuildingLabel",
  },
];

export const ReportingViewSelector: React.FC<Props> = ({
  viewType,
  setViewType,
  setTabType,
}) => {
  const { t } = useTrans();

  return (
    <div className="border-grey3 inline-flex gap-[3px] rounded-[8px] border bg-white p-[3px]">
      {BUTTONS.map((button) => (
        <button
          key={button.id}
          onClick={() => {
            setViewType(button.id);
            setTabType(REPORTING_TAB_TYPES.TOTAL);
          }}
          className={twMerge(
            "font-dm-sans cursor-pointer rounded-[6px] border-none px-[15px] py-[7px] text-[13px] font-medium whitespace-nowrap transition-all duration-150",
            viewType === button.id
              ? "bg-[#1D1C1C] font-semibold text-white"
              : "text-grey6 bg-white",
          )}
        >
          {t(button.labelKey)}
        </button>
      ))}
    </div>
  );
};
